var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transparent-field transparent-select-field"},[_c('select-field',{attrs:{"label":_vm.label,"formData":_vm.formData,"options":_vm.options,"valuePath":"value"},on:{"change":function($event){return _vm.changed($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }